var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "page-selfie",
      class: {
        "is-selfie-active": _vm.selfieActive,
        "scrollable-container": _vm.isMobile,
      },
    },
    [
      _vm.isPreparingEnvironment
        ? _c("loading-preparation", {
            attrs: { title: _vm.messages.loadingEnvironment },
          })
        : _vm.isInitializingCapture
        ? _c("loading-preparation", {
            attrs: { title: _vm.messages.loadingCamera },
          })
        : _vm.isSubmittingSelfie
        ? _c("loading-preparation", {
            attrs: { "show-spinner": true, title: _vm.messages.processing },
          })
        : !_vm.startCapture && !_vm.alert.show
        ? _c("section", { staticClass: "section-centered section-sm" }, [
            _c("div", { staticClass: "container" }, [
              _c(
                "div",
                { staticClass: "row row-grid justify-content-center" },
                [
                  _c("div", { staticClass: "text-center" }, [
                    _c("div", [
                      _c("img", {
                        staticClass: "selfie-ilustration",
                        attrs: {
                          src: "img/icons/selfie/SelfieBiometricsIllustration.png",
                          alt: "selfieIlustration",
                        },
                      }),
                    ]),
                    _c("div", [
                      _c("h2", { staticClass: "display-3" }, [
                        _vm._v("Vamos validar sua selfie"),
                      ]),
                      _c("p", { staticClass: "heading-subtitle" }, [
                        _vm._v("Dicas para tirar uma boa imagem"),
                      ]),
                    ]),
                    _c("div", { staticClass: "instructions" }, [
                      _c("div", { staticClass: "content-instruction" }, [
                        _c("img", {
                          attrs: {
                            src: "img/icons/common/LightIcon.png",
                            alt: "IconLight",
                          },
                        }),
                        _c("p", [_vm._v("Escolha um local iluminado")]),
                      ]),
                      _c("div", { staticClass: "content-instruction" }, [
                        _c("img", {
                          attrs: {
                            src: "img/icons/common/NoGlasses.png",
                            alt: "IconGlasses",
                          },
                        }),
                        _c("p", [_vm._v("Não use óculos, chapéu nem boné")]),
                      ]),
                      _c("div", { staticClass: "content-instruction" }, [
                        _c("img", {
                          attrs: {
                            src: "img/icons/common/EmotionSatisfied.png",
                            alt: "IconHair",
                          },
                        }),
                        _c("p", [_vm._v("Evite deixar o cabelo no rosto")]),
                      ]),
                      _c("div", { staticClass: "content-instruction" }, [
                        _c("img", {
                          attrs: {
                            src: "img/icons/common/FocusFace.png",
                            alt: "IconFace",
                          },
                        }),
                        _c("p", [_vm._v("Enquadre o seu rosto")]),
                      ]),
                      _c("div", { staticClass: "content-instruction" }, [
                        _c("img", {
                          attrs: {
                            src: "img/icons/common/ClearBackground.png",
                            alt: "IconBackground",
                          },
                        }),
                        _c("p", [_vm._v("Use um fundo claro e sem estampas")]),
                      ]),
                    ]),
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-primary mb-3 mb-sm-0",
                        attrs: { type: "submit" },
                        on: {
                          click: function ($event) {
                            return _vm.capture()
                          },
                        },
                      },
                      [_vm._v("\n            Estou pronto\n          ")]
                    ),
                  ]),
                ]
              ),
            ]),
          ])
        : _c("div", { staticClass: "position-relative" }, [
            _c("div", { staticClass: "container" }, [
              _c(
                "div",
                { staticClass: "row row-grid justify-content-center" },
                [
                  !_vm.selfieActive && !_vm.alert.show
                    ? _c("div", { staticClass: "col-lg-12 text-center" }, [
                        _c(
                          "div",
                          {
                            staticClass:
                              "d-flex flex-column justify-space-between align-center",
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "flex-item item flex-image" },
                              [
                                _c("img", {
                                  directives: [
                                    {
                                      name: "lazy",
                                      rawName: "v-lazy",
                                      value: "img/icons/selfie/selfie_icon.png",
                                      expression:
                                        "'img/icons/selfie/selfie_icon.png'",
                                    },
                                  ],
                                  staticClass: "card-img",
                                }),
                              ]
                            ),
                          ]
                        ),
                        _c(
                          "div",
                          [
                            _c("h1", { staticClass: "display-3" }, [
                              _vm._v("Vamos validar"),
                              _c("br"),
                              _vm._v("sua selfie"),
                            ]),
                            _c("p", { staticClass: "lead" }, [
                              _vm._v(
                                "\n              Hora de tirar sua foto de identificação.\n            "
                              ),
                            ]),
                            _c(
                              "div",
                              { staticClass: "btn-wrapper" },
                              [
                                _vm.hasError
                                  ? _c(
                                      "base-button",
                                      {
                                        staticClass:
                                          "btn btn-primary mb-3 mb-sm-0",
                                        attrs: { icon: "fa fa-repeat" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.retryProcess()
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                Tentar novamente\n              "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ],
                              1
                            ),
                            _vm.hasError
                              ? _c(
                                  "b-message",
                                  { attrs: { type: "is-danger" } },
                                  [
                                    _c("span", {
                                      domProps: {
                                        innerHTML: _vm._s(
                                          _vm.$t(`errors.${_vm.errorMsg}`)
                                        ),
                                      },
                                    }),
                                  ]
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                      ])
                    : _vm._e(),
                  _vm.alert.show
                    ? _c("slide-y-up-transition", [
                        _c(
                          "div",
                          {
                            staticClass: "col-lg-12 text-center alert-message",
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "d-flex flex-column justify-space-between align-center",
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "flex-item item flex-image" },
                                  [
                                    _c("img", {
                                      directives: [
                                        {
                                          name: "lazy",
                                          rawName: "v-lazy",
                                          value: "img/icons/common/fail.png",
                                          expression:
                                            "'img/icons/common/fail.png'",
                                        },
                                      ],
                                      staticClass: "card-img",
                                    }),
                                  ]
                                ),
                              ]
                            ),
                            _c("h1", { staticClass: "display-3" }, [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.alert.title) +
                                  "\n            "
                              ),
                            ]),
                            _c("p", [_vm._v(_vm._s(_vm.alert.message))]),
                            _c(
                              "base-button",
                              {
                                staticClass: "btn btn-primary mb-3 mb-sm-0",
                                on: {
                                  click: function ($event) {
                                    return _vm.alert.action()
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.alert.textButton) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ])
                    : _vm._e(),
                ],
                1
              ),
            ]),
          ]),
      _vm.showBranding
        ? _c("div", { staticClass: "selfie-branding" }, [
            _c("img", {
              attrs: { src: _vm.client.logo, alt: "" },
              on: {
                error: function ($event) {
                  _vm.brandingFailed = true
                },
              },
            }),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }